import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { getpositionhistory, getINRtardehistory } from "../../../Services/Admin/Addmin";
import { fDateTime, fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { useLivePrices } from "../../../context/LivePriceContext";

const Position = () => {


  const TokenData = getUserFromToken();

  const user_id = TokenData?.user_id;
  const Role = TokenData?.Role;

  const { livePrices } = useLivePrices();

  const [originalData, setOriginalData] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState(null);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activeMarket, setActiveMarket] = useState("USD");
const decimalPoint = activeMarket === "INR" ? 9 : 3;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);


  // const columns = [
  //   { Header: "userName", accessor: "username" },

  //   { Header: "Symbol", accessor: "symbol" },
  //   {
  //     Header: "Entry Price",
  //     accessor: "buy_price",
  //     Cell: ({ cell }) => {
  //       const buy_price = cell.row.buy_price;
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "buy_sell") {
  //         return buy_price ? buy_price.toFixed(3) : "-";
  //       } else {
  //         return cell.row.sell_price ? cell.row.sell_price.toFixed(3) : "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "Exit Price",
  //     accessor: "sell_price",
  //     Cell: ({ cell }) => {
  //       const buy_price = cell.row.buy_price;
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "sell_buy") {
  //         return buy_price ? buy_price.toFixed(3) : "-";
  //       } else {
  //         return cell.row.sell_price ? cell.row.sell_price.toFixed(3) : "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "P/L",
  //     accessor: "P/L",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;
  //       const sellPrice = cell.row.sell_price;
  //       const buyPrice = cell.row.buy_price;
  //       const buyQty = cell.row.buy_qty;

  //       if (sellPrice && buyPrice && buyQty) {
  //         const profitLoss = (sellPrice - buyPrice) * buyQty;
  //         const formattedProfitLoss = profitLoss.toFixed(4);

  //         const color = profitLoss > 0 ? "green" : "red";

  //         return (
  //           <span style={{ color }}>
  //             {formattedProfitLoss}
  //           </span>
  //         );
  //       }

  //       return "-";
  //     },
  //   },
  //   {
  //     Header: "Entry lot",
  //     accessor: "buy_lot",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "buy_sell") {
  //         return cell.row.buy_lot ? cell.row.buy_lot : "-";
  //       } else {
  //         return cell.row.sell_lot ? cell.row.sell_lot : "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "Exit lot",
  //     accessor: "sell_lot",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "sell_buy") {
  //         return cell.row.buy_lot ? cell.row.buy_lot : "-";
  //       } else {
  //         return cell.row.sell_lot ? cell.row.sell_lot : "-";
  //       }
  //     },
  //   },

  //   {
  //     Header: "Signal Type",
  //     accessor: "signal_type",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;

  //       return (
  //         <>
  //           {signal_type === "buy_sell" ? (
  //             <span style={{ color: "green" }}> BUY</span>
  //           ) : signal_type === "sell_buy" ? (
  //             <span style={{ color: "red" }}> SELL</span>
  //           ) : (
  //             <span style={{ color: "blue" }}> {signal_type}</span>
  //           )}
  //         </>
  //       );
  //     },
  //   },

  //   {
  //     Header: "Entry Time",
  //     accessor: "buy_time",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;

  //       if (signal_type === "buy_sell") {
  //         return cell.row.buy_time ? fDateTimesec(cell.row.buy_time) : "-";
  //       } else {
  //         return cell.row.sell_time ? fDateTimesec(cell.row.sell_time) : "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "Exit time",
  //     accessor: "sell_time",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;

  //       if (signal_type === "sell_buy") {
  //         return cell.row.buy_time ? fDateTimesec(cell.row.buy_time) : "-";
  //       } else {
  //         return cell.row.sell_time ? fDateTimesec(cell.row.sell_time) : "-";
  //       }
  //     },
  //   },

  // ];

  const columns = [
  { Header: "userName", accessor: "username" },

  { Header: "Symbol", accessor: "symbol" },

  {
    Header: "Entry Price",
    accessor: "buy_price",
    Cell: ({ row }) => {
      const buy_price = row.buy_price;
      const signal_type = row.signal_type;

      if (signal_type === "buy_sell") {
        return buy_price ? buy_price.toFixed(decimalPoint) : "-";
      } else {
        return row.sell_price ? row.sell_price.toFixed(decimalPoint) : "-";
      }
    },
  },

  {
    Header: "Exit Price",
    accessor: "sell_price",
    Cell: ({ row }) => {
      const buy_price = row.buy_price;
      const sell_price = row.sell_price;
      const signal_type = row.signal_type;
      const livePrice = activeMarket === "INR" ? livePrices[row.token] : livePrices[row.symbol?.toLowerCase()];

      if (signal_type === "sell_buy") {
        return buy_price ? buy_price.toFixed(decimalPoint) : (livePrice ? Number(livePrice).toFixed(decimalPoint) : "-");
      } else {
        return sell_price ? sell_price.toFixed(decimalPoint) : (livePrice ? Number(livePrice).toFixed(decimalPoint) : "-");
      }
    },
  },

  {
    Header: "P/L",
    accessor: "P/L",
    Cell: ({ row }) => {
      const signal_type = row.signal_type;
      const sellPrice = row.sell_price;
      const buyPrice = row.buy_price;
      const qty = row.buy_qty || row.buy_lot || row.sell_qty || row.sell_lot || 0;

      if (sellPrice && buyPrice) {
        const profitLoss = (sellPrice - buyPrice) * qty;
        const formatted = profitLoss.toFixed(decimalPoint);
        const color = profitLoss > 0 ? "green" : "red";

        return <span style={{ color }}>{formatted}</span>;
      } else {
        const livePriceVal = activeMarket === "INR" ? livePrices[row.token] : livePrices[row.symbol?.toLowerCase()];
        if (livePriceVal) {
          const livePrice = Number(livePriceVal);
          let profitLoss = 0;
          if (signal_type === "buy_sell") {
            profitLoss = (livePrice - buyPrice) * qty;
          } else if (signal_type === "sell_buy") {
            profitLoss = (sellPrice - livePrice) * qty;
          }
          const formatted = profitLoss.toFixed(decimalPoint);
          const color = profitLoss > 0 ? "green" : "red";
          return <span style={{ color }}>{formatted}</span>;
        }
      }

      return "-";
    },
  },

  {
    Header: "Entry lot",
    accessor: "buy_lot",
    Cell: ({ row }) => {
      if (row.signal_type === "buy_sell") {
        return row.buy_lot ? row.buy_lot : "-";
      } else {
        return row.sell_lot ? row.sell_lot : "-";
      }
    },
  },

  {
    Header: "Exit lot",
    accessor: "sell_lot",
    Cell: ({ row }) => {
      if (row.signal_type === "sell_buy") {
        return row.buy_lot ? row.buy_lot : "-";
      } else {
        return row.sell_lot ? row.sell_lot : "-";
      }
    },
  },

  {
    Header: "Signal Type",
    accessor: "signal_type",
    Cell: ({ row }) => {
      const type = row.signal_type;

      return (
        <>
          {type === "buy_sell" ? (
            <span style={{ color: "green" }}>BUY</span>
          ) : type === "sell_buy" ? (
            <span style={{ color: "red" }}>SELL</span>
          ) : (
            <span style={{ color: "blue" }}>{type}</span>
          )}
        </>
      );
    },
  },

  {
    Header: "Entry Time",
    accessor: "buy_time",
    Cell: ({ row }) => {
      if (row.signal_type === "buy_sell") {
        return row.buy_time ? fDateTimesec(row.buy_time) : "-";
      } else {
        return row.sell_time ? fDateTimesec(row.sell_time) : "-";
      }
    },
  },

  {
    Header: "Exit time",
    accessor: "sell_time",
    Cell: ({ row }) => {
      if (row.signal_type === "sell_buy") {
        return row.buy_time ? fDateTimesec(row.buy_time) : "-";
      } else {
        return row.sell_time ? fDateTimesec(row.sell_time) : "-";
      }
    },
  },
];

  const getuserallhistory = async () => {
    try {
      const data = { userid: user_id, Role: Role , page: page, limit: rowsPerPage, search: search };
      let response;
      if (activeMarket === "INR") {
        response = await getINRtardehistory(data);
      } else {
        response = await getpositionhistory(data);
      }
      if (response.status) {
        setData(response.data || []);
        setTotalPages(response.pagination?.totalPages || 1);
      }


    } catch (error) { }
  };

  useEffect(() => {
    getuserallhistory();
  }, [activeMarket, page, rowsPerPage, search,]);



  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newLimit) => {
    setRowsPerPage(newLimit);
    setPage(1); // reset page when limit changes
  };


  return (
    <>
      <div>
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="card transaction-table custom-bg">
                <div className="card-header border-0 flex-wrap ">
                  <div className="mb-2">
                    <h4 className="card-title ">Position</h4>
                  </div>
                  <div className="wallet-tabs ">
                    <div className="btn-group" role="group">
                      {TokenData?.market.includes(0) && (
                        <button
                          type="button"
                          className={`btn ${activeMarket === "USD"
                            ? "btn-primary"
                            : "btn-outline-primary"
                            }`}
                          onClick={() => setActiveMarket("USD")}
                        >
                          <i className="fas fa-dollar-sign me-2"></i>
                          USD Wallet
                        </button>
                      )}

                      {TokenData?.market.includes(1) && (
                        <button
                          type="button"
                          className={`btn ${activeMarket === "INR"
                            ? "btn-primary"
                            : "btn-outline-primary"
                            }`}
                          onClick={() => setActiveMarket("INR")}
                        >
                          <i className="fas fa-rupee-sign me-2"></i>
                          INR Wallet
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="tab-content" id="myTabContent1">
                    <div
                      className="tab-pane fade show active"
                      id="Week"
                      role="tabpanel"
                      aria-labelledby="Week-tab"
                    >
                      <div className="mb-3 ms-4">

                        <div className="d-flex align-items-center mb-3">

                          <div className="me-3 mt-3">
                            <label className="form-label">🔍 Search:</label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Search..."
                              value={search}
                              onChange={(e) => {
                                setSearch(e.target.value)
                                setPage(1)
                              }}
                            />
                          </div>

                        </div>
                      </div>

                      <Table
                        columns={columns}
                        data={data}
                        page={page}
                        totalPages={totalPages}
                        initialRowsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                      />
                      {/* <div
                        className="d-flex align-items-center"
                        style={{
                          marginBottom: "20px",
                          marginLeft: "20px",
                          marginTop: "-48px",
                        }}
                      >
                        Rows per page:{" "}
                        <select
                          className="form-select ml-2"
                          value={rowsPerPage}
                          onChange={(e) =>
                            setRowsPerPage(Number(e.target.value))
                          }
                          style={{ width: "auto", marginLeft: "10px" }}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Position;
